import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IBaseModel } from 'src/app/models/base.model';
import { RiscosChavesServices } from 'src/app/services/riscos-chaves.service';
import { CriteriosAvaliacaoRiscoService } from 'src/app/services/criterios-avaliacao-risco.service';
import { TipoUniversoService } from 'src/app/services/tipo-universo.service';
import { IRiscosChavesModel } from 'src/app/models/riscos-chaves.model';
import { IUniversoAuditavelModel } from 'src/app/models/universo-auditavel.model';
import { BaseFormComponent } from 'src/app/shared/components/base-form/base-form.component';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { ITipoUniversoModel, 
  ITipoUniversoItemModel, 
  ITipoUniversoUGModel 
} from 'src/app/models/tipo-universo.model';




@Component({
  selector: 'app-riscos-chaves-form',
  templateUrl: './riscos-chaves-form.component.html',
  styleUrls: ['./riscos-chaves-form.component.scss']
})
export class RiscosChavesFormComponent extends BaseFormComponent implements OnInit {

  public tipoUniversoId : number;
  public unidadeGestoraId : number;
  public criterioAvaliacaoId: number;
  public criterioId: string;
  public unidadeGestora: number;
  public processoId: number;
  public semDados: boolean;
  public modelRiscosChaves : IRiscosChavesModel = {} as IRiscosChavesModel;
  public modelTipoUniverso : ITipoUniversoModel = {} as ITipoUniversoModel;
  public modelTipoUniversoItens : ITipoUniversoUGModel = {} as ITipoUniversoUGModel;
  public idClassificacaoTipo: number;
 
  

  constructor(route: ActivatedRoute, 
              toastr: ToastrService,
              router: Router,
              localeService: BsLocaleService,
              private riscosChavesService: RiscosChavesServices,
              private tipoUniversoService: TipoUniversoService,
              private criterioAvaliacaoService: CriteriosAvaliacaoRiscoService,
              public matDialog: MatDialog,
            ) {
    super(route, toastr, router, localeService, matDialog);
   }

  async ngOnInit() {

    if(this.id){
      const res = await this.riscosChavesService.obterPorId(this.id);
      if(res.sucesso){
        this.tipoUniversoId = res.dados.tipoUniversoAuditavelId;   
        this.unidadeGestoraId = res.dados.unidadeGestoraId;
        this.criterioAvaliacaoId = res.dados.criterioAvaliacaoId;

      }
    
    }
    if(this.tipoUniversoId != null){
      this.buscarTipoUniverso(this.tipoUniversoId);
    }
  }

  public async buscarTipoUniverso(idTipo:number){
    const res = await this.tipoUniversoService.obterPorId(idTipo);
    if(res.sucesso){
      this.idClassificacaoTipo = res.dados.tipo;
    }
    this.buscarItens(this.tipoUniversoId, this.unidadeGestoraId);
  }

  public async buscarItens(idTipoUniverso: number, idUG: number){
    const paramsUG = this.idClassificacaoTipo == 2 ? idUG : null;

    if(idTipoUniverso){
      const res = await this.tipoUniversoService.obterItens(idTipoUniverso, paramsUG);
      if(res.sucesso){
        this.modelTipoUniversoItens = res.dados;
        this.criterioId = this.criterioAvaliacaoId.toString();
      }else{
        this.exibirMensagemErro(res.mensagem.descricao);
      }

    }
  }

  public async abrirPreenchimento(processoId: number){
    
    const res = await this.criterioAvaliacaoService.obterPorId(this.criterioAvaliacaoId);
    if(res.sucesso){
      if(this.id)
        this.router.navigate([`/preenchimento-riscos-criterios`,this.id, processoId]);
    }

  }

  getRowSpan(subtipo: any): number {
    let rowCount = 0;
    subtipo.itens.forEach(macro => {
      if (macro.tipo === 2) {
        rowCount += macro.itens.length || 1; // Se não houver processos, contar pelo menos 1 linha
      }
    });
    return rowCount || 1; // Se não houver macros, contar pelo menos 1 linha
  }

}


